import services from './../../services/service'; // Service Class
// import MainHeader from './../MainHeader/index.vue'; // Main Header
// import MainFooter from './../MainFooter/index.vue'; // Main Footer
// import MenuBottom from './../../components/templates/menubottom.vue'; 
// import Settings from './../../components/tools/settings.vue';
// import Commons from '../../resources/commons.js'; //Commons class

// //push-notification
// import { Capacitor } from '@capacitor/core';
// import {PushNotifications} from '@capacitor/push-notifications';
// //../push-notification

let service = new services();

export default {
    name: 'Home',
    //mixins: [Commons],
    data () {
        return {
            user:{},
            market:{},
            business:{},
            categories:{},
            subscriptions:{},
            plan1:{},
            plan2:{},
            plan3:{},
            selected_plan:{},
            place_order:false,
            //boarding_messages:[],
            data_boarding_message:"",
            set_up_with_existing_account: false,
            set_up_with_new_account:false,
            set_up_business:false,
            validate_user_name_error:false,
            data_error_message: "",
            payment_successful: false,
            payment_successful_message: "",
            payment_payer_name:"",
            payment_payer_email:"",
            payment_payer_phone:"",
            payment_service:"",
            img_sellpoint_url: service.imageSellpointsURL,
            img_product_url: service.imageProductsURL,
            loggedIn: false,
            loading: true,
            disable_btn:false,
        }
    },
  
    components: {
        // 'component-header': MainHeader,
        // 'component-footer': MainFooter,
        // 'component-menu-bottom': MenuBottom,
        // 'c-settings':Settings,
    },
    computed: {
        
    },
    methods: {
        preset() {
            let self = this;
            localforage.getItem(service.udb_name, function(err, value) { //quick with the callback version
                if(value != undefined) {
                    self.loggedIn = true;
                    //self.$router.push('/timeline');
                    self.user.user_id = value.user_id;
                }
            });
        },

        setComponent(attr1,attr2){
            if(attr1 == 'setup-existing'){
                this.set_up_with_existing_account = true;
            }
        },

        toggleFAQComponent(action,show,hide,head,body){
            if(action == 'show'){
                // document.getElementById("faqAction").innerHTML = "-";
                document.getElementById(show).style.display = "none";
                document.getElementById(hide).style.display = "block";
                document.getElementById(head).style.color = "#ff0000";
                document.getElementById(body).style.display = "block";
            }
            if(action == 'hide'){
                // document.getElementById("faqAction").innerHTML = "+";
                document.getElementById(show).style.display = "block";
                document.getElementById(hide).style.display = "==none";
                document.getElementById(head).style.color = "#777b92";
                document.getElementById(body).style.display = "none";
            }
            
            
        },

        getSellpointMarket(){
            service.getBusinessByUserName(this, service.market_app_name).then(response => {
                if(response.body.status == 200) {
                    this.market = response.body.data;
                    //document.title = this.sellpoint.business_name;
                    
                    //get market details
                    this.getMarketMainProductsAsSubscriptions();
                     

                    this.loading = false;

                }
            }).catch((err) => {})
        },
        getMarketMainProductsAsSubscriptions(){
            service.getBusinessProducts(this, this.market.business_id).then(response => {
                if(response.body.status == 200) {
                    this.subscriptions = response.body.data;
                    this.plan1 = this.subscriptions[2];
                    this.plan2 = this.subscriptions[1];
                    this.plan3 = this.subscriptions[0];
                }
            }).catch((err) => {})
                
        },

        purchase_plan(plan,plan_product_service_item_index){
            this.loading = true;
            this.selected_plan = plan;
            this.place_order = true;
            //$('#purchaseModal').modal('show');
            // this.$router.push('purchase/?purchase='+plan.product_url_name);
            this.$router.push('/purchase/?purchase='+plan.product_url_name+'&item='+plan_product_service_item_index);
        },

        resetOptions(){
            this.selected_plan = {};
            this.total_price = 0;
            this.place_order = false;
        },

        resetMessages(){
            this.data_error_message = "";
            this.data_boarding_message = "";
            this.payment_successful_message = "";
            this.validate_user_name_error = "";
        },
        
        proceedNewAccount(){
            this.resetMessages();
            this.set_up_with_new_account = true;

            if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
                this.updatePayment("gw-free-account")
            }else{
                //proceed to pay
                this.processPayment();
            }
                        
            //test-switch
            // this.updatePayment("reffy");
        },

        proceedWithAccount(){
            this.resetMessages();
            var payload = {
                user_email: this.user.user_email,
                user_password: this.user.user_password,
                user_business: this.user.user_business
            }
            service.checkUserDetails(this, payload).then(function(data) {
                if(data.body.status == 200) {
                    if(data.body.status_2 != 200) {
                        this.data_error_message = "Sorry, Sellpoint does not exist on this account";
                       // toastr.warning("Sorry, Sellpoint does not exist on this account", 'Warning!');
                    }else{
                        //all good proceed
                        this.payment_payer_name = data.body.data.user_name;
                        this.payment_payer_email = data.body.data.user_email;
                        this.payment_payer_phone = data.body.data.user_phone;

                        if(this.selected_plan.product_items[0].product_item_price == 0){ //free account
                            this.updatePayment("gw-free-account")
                        }else{
                            //proceed to pay
                            this.processPayment();
                        }
                        
                        //test-switch
                        // this.updatePayment("reffy");

                    }
                }else{
                    this.data_error_message = "Sorry, Account does not exist";
                   // toastr.warning("Sorry, Account does not exist", 'Warning!');
                }
            }).catch((err) => {})
        },

        //connect to a payment gateway
        processPayment() {
            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                 //process online payment
                    this.payment_service = "Gallery Website Order - " + this.selected_plan.product_name+"("+this.selected_plan.product_items[0].product_item_price+")";
                    let obj = this;
                    //this.amount_paid = data.plan_amount;
                    var handler = PaystackPop.setup({
                    // key: 'pk_live_64fe633bf8a53b0346ef8a44f54dc41cc0aa9f8b',
                    key: 'pk_test_1b578e2fe82975a4ec8a79e5d1a387c953fd2c3e',
                    Name: this.payment_payer_name,
                    // email: data.plan_user_email || "admin@sellpoints.ng",
                    email: this.payment_payer_email,
                    amount:  (Math.round(this.selected_plan.product_items[0].product_item_price * 100)),//(data.plan_amount * 100), //in kobo
                    ref: "GWLOG"+Math.random(),
                    metadata: {
                        custom_fields: [
                            {
                                display_name: "GalleryWebsite Order",
                                variable_name: "",
                                value: this.payment_payer_name + " - " + this.payment_payer_phone + " - ORDER - " + this.selected_plan.product_name
                            },
                            {
                                display_name: "Service",
                                variable_name: "service_type",
                                value: this.selected_plan.product_name
                            }
                            
                        ]
                    },
                    
                    callback: function(response){
                        obj.updatePayment(response.trxref); 
                    },
                    onClose: function(){
                        alert('window closed');
                    }
                    });
                    handler.openIframe();
                }

        },

        // update payments
        updatePayment(payment_ref) {

            //notify server
            //.......................................

            // var payload = {
            //     payment_order_ref: payment_ref,
            //     payment_user_id: this.user.user_id
            // }
            //.......................................
            

            let navi = this.$router;
            this.payment_successful = true;
            this.payment_successful_message = "Payment Successful...";
            
            //set up account on gw
            if(this.set_up_with_existing_account){
               this.setUpExistingAccount();
            }
            if(this.set_up_with_new_account){
                this.setUpNewAccount();
            }

        },

        setUpExistingAccount(){
            //register users business to gallery app
            this.disable_btn = true;
            var credentials = {
                business_user_name: this.user.user_business,
                business_group: service.market_app_name,
                business_subscription: this.selected_plan.product_id
            }
            
            let navi = this.$router; 
            service.addExistingBusiness(this, credentials).then(function(data) {
                if(data.body.status == 201) {
                    this.boarding_messages.push("Sellpoint Setup Successful...");
                     //navi.push('/'+this.user.user_business);
                    //log user in
                    var credentials = {
                        user_email: this.user.user_email,
                        user_password: this.user.user_password
                    }
                    service.loginUser(this, credentials).then(response => {
                        if(response.body.status == 200) {
                            let data = response.body.data;
                            localStorage.setItem("sp_user", data.user_name); 
                            localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                            localStorage.setItem("sp_token_key", data.user_token_key); 
                           
                            //all good
                            //and ask user for business name to create the sp
                            $('#purchaseModal').modal('hide');
                            navi.push('/'+this.user.user_business);
                        }
                    }).catch((err) => {
                        if(err.status == 404) {
                            toastr.warning("invalid login credentials", 'Warning!'); 
                            this.disable_btn = false;
                        }
                    })
                }
            }).catch((err) => {
                if(err) {
                    toastr.warning("Something went wrong", 'Warning!'); 
                    this.disable_btn = false;
                }
            })
        },

        setUpNewAccount(){
            //create account by registering user
            this.disable_btn = true;
            this.loading = true; //activate loading
            //this.user.agree = true; ///change 
            var credentials = {
                user_name: this.payment_payer_name,
                user_phone: this.payment_payer_phone,
                user_email: this.payment_payer_email,
                user_address:  '',
                user_state: '',
                user_city: '',
                user_password: this.user.user_password
            }


            let navi = this.$router;

            //test data
            let data_test = false;
            var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            let email_test = re.test(String(this.payment_payer_email).toLowerCase());
            var re_phone = /^\d{4}\d{3}\d{4}$/;
            let phone_test = re_phone.test(String(this.payment_payer_phone).toLowerCase());
            if((email_test == false) || (this.payment_payer_name == " ") || (phone_test == false)){
                data_test = false;
                this.data_error_message = "Some errors were found in your form, please fill correctly";
            }else{
                data_test = true;
                this.data_error_message = "";
            }
            if(data_test){
                if(credentials.user_name != undefined && credentials.user_address != undefined && credentials.user_phone != null &&
                credentials.user_email != null && credentials.user_password != null) {
                    service.regUser(this, credentials).then(function(data) {
                        if(data.body.status == 201) {
                        // toastr.success("Registration Successful", 'Success!');
                        this.data_boarding_message ="Registration Successful...";
                            //log user in
                            var credentials = {
                                user_email: data.body.data.user_email,
                                user_password: data.body.data.user_password
                            }
                            service.loginUser(this, credentials).then(response => {
                                if(response.body.status == 200) {
                                    let data = response.body.data;
                                    localStorage.setItem("sp_user", data.user_name); 
                                    localStorage.setItem("sp_token", data.user_session_key); //store session key here linked to session well @server
                                    localStorage.setItem("sp_token_key", data.user_token_key); 
                                
                                    //all good
                                    //reauth and preset to get actual user details
                                    this.preset();
                                    //and ask user for business name to create the sp
                                    setTimeout(function(){ 
                                        this.set_up_business = true;
                                        $('#purchaseModal').modal('hide');
                                        $('#newBusinessModal').modal('show');
                                    }, 3000); //wait for 3sec and c
                                    
                                }
                            }).catch((err) => {
                                if(err.status == 404) {
                                    //toastr.warning("invalid login credentials", 'Warning!'); 
                                    this.data_error_message = "invalid login credentials..";
                                    this.disable_btn = false;
                                }
                            })
                        }else if(data.body.status == 409) {
                            //toastr.warning("This User is already registered", 'Warning!');
                            this.data_error_message = "This User is already registered..";
                            this.disable_btn = false;
                        }
                    })
                }else {
                    //toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields...";
                    this.disable_btn = false;
                }
            }
        },

        validateUserName(){
            service.validateBusinessUserName(this, this.business).then(response => {
                if(response.body.status != 200) {
                    this.validate_user_name_error = true;
                    this.validate_user_name_message = "This username already exist";
                }
            }).catch((err) => {
                //log it
                this.validate_user_name_error = true;
                this.validate_user_name_message = "This username already exist";
            })
        },
        
        setUpNewAccountBusiness(){
            this.resetMessages();
            this.disable_btn = true;
            var credentials = {
                business_name: this.business.business_name,
                business_user_name: this.business.business_user_name,
                business_category: this.business.business_category || 1,
                business_owner: this.user.user_id,
                business_group: service.market_app_name,
                business_layout: this.business.business_view_layout || 3, //gallery
                business_subscription: this.selected_plan.product_id
            }
            let navi = this.$router;
            if(this.validate_user_name_error){
              //  toastr.error('This Username already exists', 'Warning!');
                this.data_error_message = "This Username already exists..";
            }else{
                if(credentials.business_name != undefined && credentials.business_category != undefined) {
                    service.addNewBusiness(this, credentials).then(function(data) {
                            if(data.body.status == 201) {
                               // toastr.success("Sellpoint Creation Successfull", 'Success!');
                                this.data_boarding_message = "Sellpoint Creation Successful.";
                                
                                $('#newBusinessModal').modal('hide');
                                navi.push('/'+this.business.business_user_name);
                            }else{
                                this.data_error_message = "This Username already exists";
                            }
                        }).catch((err) => {
                           if(err) {
                              //  toastr.warning("Something went wrong", 'Warning!'); 
                                this.data_error_message = "Something went wrong";
                                this.disable_btn = false;
                           }
                        })
                   
                }else {
                    // toastr.error('Kindly fill all fields', 'Warning!');
                    this.data_error_message = "Kindly fill all fields";
                    this.disable_btn = false;
                }
            }
        },
        
        getBusinessCategories() {
            service.getCategories(this).then(function(data) {
                this.categories = data.body.data;
            })
        },

        creation_thread(){
            //promises hub
            let promises = [];
            for (let i = 0; i < 9; ++i) {
                if(i == 1){
                    promises.push(
                        this.preset()
                    )
                }
                if(i == 2){
                    promises.push(
                        this.getSellpointMarket()
                    )
                }
                
            }
        
            //process all promises
            Promise.all(promises)
            .then(() => {
                //process one by one to implement wait time
                var result = Promise.resolve();
                promises.forEach(promise => { //loop through each promise and resolve one after the other
                    result.then(() => {});
                });
            })
            .catch((e) => {});
            //..promises hub
           
        },

    },

    mounted: function(){
        //this.setPushNotification();
    },
  
    created: function(){
        let self = this
        setTimeout(function(){
            location.replace('/')
        },2500);
       //this.creation_thread();
        
    }
}


// WEBPACK FOOTER //
// ./src/pages/Home/script.js